<template>
  <div>
    <app-header title="合并账号" back-type="back-app" />
    <div class="container">
      <p class="title_box">已成功合并账号，请使用以下账号登录学习</p>
      <div class="flexbox acount">
        <img :src="info.avatarUrl" class="acount_img" alt="" />
        <div class="acount_info">
          <h5>{{ info.nickName }}</h5>
          <p>手机号：{{ info.mobile }}</p>
          <p>友邻少年ID：{{ info.userId }}</p>
          <p>注册时间：{{ info.registDate }}</p>
        </div>
      </div>
      <div class="flexbox next_box" @click="next">下一步</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { storage } from '@/utils'
import { $mergeAccountFinish } from '@/utils/common/native-api'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters('acount', ['previewList', 'activeIndex', 'unChoose', 'isNative', 'isWeixin']),
    info() {
      return this.previewList[this.activeIndex]
    }
  },
  methods: {
    next() {
      if (this.isNative) {
        // 原生跳转
        return $mergeAccountFinish()
      }
      // 清除登录痕迹
      const hash = storage.loginNextHash()
      if (hash) {
        storage.loginNextHash().remove()
        storage.loginNextAction().remove()
      }
      const url = sessionStorage.getItem('wxMergeRebackUrl') || ''
      if (this.isWeixin && url) {
        return location.replace(url)
      }
      this.$router.replace({
        path: 'login'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 0.32rem 0.48rem;
  .title_box {
    font-size: 0.28rem;
    margin-bottom: 0.48rem;
  }
}
.acount {
  align-items: flex-start;
  border-radius: 0.16rem;
  padding: 0.28rem;
  box-shadow: 0rem 0rem 0.2rem 0rem rgba(0, 0, 0, 0.1);
}
.acount_img {
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
  border-radius: 0.16rem;
  margin-right: 0.28rem;
}
.acount_info {
  flex: auto;
  height: 100%;
  font-size: 0.24rem;
  flex-direction: column;
  justify-content: space-between;
  h5 {
    font-size: 0.32rem;
    margin-bottom: 0.24rem;
  }
  p {
    margin-top: 0.1rem;
  }
}
.next_box {
  position: fixed;
  left: 0.48rem;
  bottom: 1.48rem;
  width: 6.54rem;
  height: 0.88rem;
  background: #00b25a;
  border-radius: 0.08rem;
  font-size: 0.32rem;
  text-align: center;
  justify-content: center;
  color: #fff;
}
</style>
